import { render, staticRenderFns } from "./MatchingQuestionScoreInput.vue?vue&type=template&id=5b30b7db&scoped=true"
import script from "./MatchingQuestionScoreInput.vue?vue&type=script&lang=js"
export * from "./MatchingQuestionScoreInput.vue?vue&type=script&lang=js"
import style0 from "./MatchingQuestionScoreInput.vue?vue&type=style&index=0&id=5b30b7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30b7db",
  null
  
)

export default component.exports